export const SERIAL_SENT = 'SERIAL_SENT';
export const CONF_SERIAL_SENT = 'CONF_SERIAL_SENT';
export const SET_QA_STATUS = 'SET_QA_STATUS';
export const ERROR_QA = 'ERROR_QA';
export const SET_PARTIAL_QA = 'SET_PARTIAL_QA';